import { useEffect, useRef, useState } from "react";
import { httpPost } from "../../../modules/Backend";
import {TableVirtuoso } from "react-virtuoso";
import { useParams } from "react-router";
import Pill from "../Pill";
import { staticSidePanelSignal } from "../layout/Layout";
import { useSignals } from "@preact/signals-react/runtime";
import { StatusDto } from "../../../enums/Domain/Status";
import SidePanelRecallPackList from "../layout/SidePanel/layouts/SidePanelRecallPackList";
import { EntityNames } from "../../../enums/EntityNames";

export interface IPickList {
  recallId: string;
  items: IPicklistItem[];
}

export interface IPicklistItem {
  id: string;
  breadcrumb: string;
  reference: string;
  type: string;
  intent: string;
  status: StatusDto;
  foundStatus: StatusDto;
  notes: string;
  requestorComments: string;
  quantity: number;
  year: number;
}

export default function RecallsPackList() {
  useSignals();

  const { recallId } = useParams();
  const [data, setData] = useState<IPicklistItem[]>([]);
  const [groupedData, setGroupedData] = useState<{ breadcrumb: string; items: IPicklistItem[] }[]>([]);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const list = useRef<any>(null);

  // Function to group data by breadcrumb
  const groupByBreadcrumb = (items: IPicklistItem[]) => {
    return items.reduce((acc: any, item: IPicklistItem) => {
      const group = acc.find((g: any) => g.breadcrumb === item.breadcrumb);
      if (group) {
        group.items.push(item);
      } else {
        acc.push({ breadcrumb: item.breadcrumb, items: [item] });
      }
      return acc;
    }, []);
  };

  async function getData() {
    const timeout = setTimeout(() => setShowLoader(true), 200);
    const result = await httpPost(`api/${EntityNames.recalls}/getPackList`, { recallId: recallId });
    if (recallId && result?.data) {
      setData(result?.data.items);
    }
    setShowLoader(false);
    clearTimeout(timeout);
  }

  function renderEmptyList(){
    return (   
      <div>
        {showLoader && data.length == 0 &&
        <div className="react-aria-Table">
          <table>
            <th><p className="small">Reference</p></th>
            <th><p className="small">Contents</p></th>
            <th><p className="small">Type</p></th>
            <th><p className="small">Year</p></th>
            <th><p className="small">Status</p></th>
            {[...Array(6)].map((e, i) => (            
                <tr>
                    {[...Array(6)].map((e, i) => (
                    <td>                        
                        <div className="loaders loaders__list"></div>
                    </td>
                    ))}                 
                </tr>
            ))}
          </table>
        </div>
      }
    </div>
    )
  }

  // Call getData on component mount
  useEffect(() => {
    getData();
  }, []);

  // Group data by breadcrumb whenever data changes
  useEffect(() => {
    if (data.length > 0) {
      const grouped = groupByBreadcrumb(data);
      setGroupedData(grouped);
    }
    staticSidePanelSignal.value = <SidePanelRecallPackList recallId={recallId!} />;
  }, [data]);

  return (
    <>
      {renderEmptyList()}
      {!showLoader &&
        <div className="height--full list__wrapper">
          <TableVirtuoso
                    className="react-aria-Table"
            data={data}
            fixedHeaderContent={() => (<tr className="">
              <th><p className="small small-2">Reference</p></th>
              <th><p className="small small-2">Contents</p></th>
              <th><p className="small small-2">Type</p></th>
              <th><p className="small small-2">Year</p></th>
              <th><p className="small small-2">Status</p></th>
            </tr>)
            }
            ref={list}
            itemContent={(index, lineItem) => {
              return (<>
                <td>
                  <p className="small-2">{lineItem.reference}</p>
                </td>
                <td>
                  <p className="small-2">{lineItem.intent}</p>
                </td>
                <td>
                  <p >{lineItem.type}</p>
                </td>
                <td>
                  <p className="small-2">{lineItem.year != 0 ? lineItem.year : '--'}</p></td>
                <td>
                  <Pill statusDto={lineItem.status} />
                </td>
              </>
              );
            }}
          />
        </div>
      }
    </>
  );
}